import React from 'react';

import { BELL_PATHS } from './bellIconPaths';

type BellIconProps = {
  color: string;
  size?: number;
  muted?: boolean;
};

/** Web bell — SVG counterpart to native Skia BellIcon. */
export function BellIcon({ color, size = 18, muted = false }: BellIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden style={{ display: 'block' }}>
      <path
        d={BELL_PATHS.outline}
        fill="none"
        stroke={color}
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {muted ? (
        <path
          d={BELL_PATHS.slash}
          fill="none"
          stroke={color}
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : null}
    </svg>
  );
}
